import Lottie from "lottie-react";
import birdAnimation from "../../assets/animations/bird.json";
import styles from "../../styles/base/Loading.module.scss";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
    endLoading: boolean;
    onComplete: () => void;
}

const Loading : React.FC<Props> = ({endLoading, onComplete}) => {
    const { t } = useTranslation()
    const [animateOut, setanimateOut] = useState(false);

    useEffect(()=>{
        if(endLoading){
            runEndAnimation();
        }
    }, [endLoading])

    const runEndAnimation = () => {
        setanimateOut(true)

        setTimeout(function(){ onComplete()}, 4000)
    }

    return (
        <div className={styles.loading}>
            <div className={`${animateOut && styles.animate_out} ${styles.animation}`}><Lottie width={250} height={250} animationData={birdAnimation} loop={true} /></div>
            <div className={styles.content}>
                <h1 className='text-2xl font-bold'>{t('Even geduld')}...</h1>
                <p className="text-center">{t('Onze mascotte is uw bestanden aan het ophalen')}</p>
            </div>
        </div>
    )
}

export default Loading;